import React from 'react';

function Quote() {
  return (
    <div>
      <h1 className="quote">Without mathematics, there’s nothing you can do. Everything around you is mathematics. Everything around you is numbers.</h1>
    </div>
  );
}

export default Quote;
